import Button from '@cashew/button';
import classNames from 'classnames';
/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable operator-linebreak */
import React, { type ChangeEvent, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Input, ModalConfirm } from '../../components';
import type { RootState } from '../../reducers';
import type { UserState } from '../../reducers/user';

const { api, priceFormat } = require('@cashew/utils');

export default ({
  orderDetails,
  showConfirmModal,
  setShowConfirmModal,
  dispatched,
}: any) => {
  type Status = 'warning' | 'error' | 'info' | 'success' | 'none';
  const { t } = useTranslation();
  const params: any = useParams();
  const { role }: UserState = useSelector((state: RootState) => state.user);
  const [showResult, setShowResult] = useState(false);
  const [resultStatus, setResultStatus] = useState<Status>('none');
  const [refundLoading, setRefundLoading] = useState(false);
  const [refundAmount, setRefundAmount] = useState('');
  const [refundError, setRefundError] = useState<any>();
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [isCheckboxDisabled, setIsCheckboxDisabled] = useState<boolean>(false);
  const [forceRender, setForceRender] = useState(1);

  const handleCheckboxChange = () => {
    if (orderDetails?.hasPurchaseFee) {
      setIsChecked(true);
    }
    setIsChecked(!isChecked);
  };

  useEffect(() => {
    if (Number(refundAmount) === Number(orderDetails.totalAmount)) {
      setIsCheckboxDisabled(false);
      setForceRender(forceRender + 1);
    } else {
      setIsCheckboxDisabled(true);
      setIsChecked(false);
      setForceRender(forceRender + 1);
    }

    if (Number(refundAmount) === Number(orderDetails?.balanceAmount)) {
      setIsCheckboxDisabled(false);
      setForceRender(forceRender + 1);
    }
  }, [Number(refundAmount), Number(orderDetails.totalAmount)]);

  const resultTitle =
    resultStatus === 'error'
      ? 'We encountered an issue'
      : `Order ${resultStatus === 'success' ? 'was' : 'was not'} refunded`;

  useEffect(() => {
    setRefundAmount(dispatched ? '' : orderDetails.totalAmount);
  }, [orderDetails]);

  const resultDescription =
    resultStatus === 'error' ? (
      <div className="resultDescriptionStatus">
        {' '}
        The order &nbsp;
        <span style={{ fontWeight: '800' }}>{orderDetails.id}</span>
        &nbsp; was not refunded, please reach out to our support by email at
        <br />
        <a
          style={{ color: '#fed01d' }}
          href="mailto:merchantsupport@cashewpayments.com"
        >
          <span style={{ fontWeight: '800' }}>
            merchantsupport@cashewpayments.com
          </span>
        </a>
        &nbsp; for assistance.
      </div>
    ) : (
      <>
        The order &nbsp;
        <span style={{ fontWeight: '800' }}>{orderDetails.id}</span>
        &nbsp;
        {resultStatus === 'success' ? 'was successfully' : 'was not'}
        &nbsp;refunded.
      </>
    );

  const isRefundAvailable = refundAmount <= orderDetails.balanceAmount;
  const confirmForm = (
    <div>
      {refundLoading && (
        <img className="loading-img" src="/loading.png" alt="Loading..." />
      )}
      <form className={refundLoading ? 'opacity-0' : ''}>
        <div className="form-row">
          <Input
            name="PriorRefunds"
            placeholder="Prior Refunds"
            value={priceFormat({
              currency: orderDetails.currencyCode,
              amount: Number(
                (orderDetails.totalAmount - orderDetails.balanceAmount).toFixed(
                  2
                )
              ),
            })}
            readonly
          />
          <div className="form-row-divider" />
          <Input
            name="grossOrderAmount"
            placeholder="Gross order total"
            value={priceFormat({
              currency: orderDetails.currencyCode,
              amount: orderDetails.totalAmount || 0,
            })}
            readonly
          />
        </div>
        <div className="form-row">
          <div className="input-hint">
            <Input
              error={!isRefundAvailable ? ' ' : undefined}
              name="shippingReference"
              placeholder="Refund amount"
              readonly={!dispatched}
              value={
                !dispatched
                  ? priceFormat({
                      currency: orderDetails?.currencyCode,
                      amount: +refundAmount,
                    })
                  : refundAmount
              }
              maxLength={20}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                const value = e.target.value.toString().split(',').join('');
                if (value.split('').includes(' ')) return;
                if (value.split('').filter((it) => it === '.').length < 2) {
                  if (Number.isNaN(Number(value))) {
                    return;
                  }
                  if (value.split('.')[1]?.length > 2) return;
                  setRefundAmount(value);
                }
              }}
            />
            <span style={{ color: isRefundAvailable ? '#5ECC61' : '#ED3833' }}>
              {isRefundAvailable
                ? 'Enter refund amount to continue.'
                : "Refund amount can't exceed the net amount available"}
            </span>
          </div>
          <div className="form-row-divider" />
          <Input
            name="customerName"
            placeholder="Net amount available"
            value={priceFormat({
              currency: orderDetails.currencyCode,
              amount: orderDetails.balanceAmount,
            })}
            readonly
          />
        </div>

      </form>
    </div>
  );

  const onRefund = () => {
    setRefundError('');
    setRefundLoading(true);
    api
      .post({
        endpoint: 'refunds',
        params: {
          orderId: params.orderId,
          refundAmount,
          cashewCustomerId: orderDetails.cashewCustomerId,
          storeId: orderDetails.storeId,
          purchaseFeeRefund: isChecked,
        },
      })
      .then(() => {
        setRefundAmount('');
        setResultStatus('success');
      })
      .catch((error: any) => {
        setResultStatus(
          error?.response?.data?.errorCode === '400.005.017'
            ? 'warning'
            : 'error'
        );
        if (error?.response?.data?.errorCode) {
          setRefundError(error.response.data.errorCode);
        }
      })
      .finally(() => {
        setShowResult(true);
        setRefundLoading(false);
      });
  };

  const confirmButtons = (
    <div style={{ display: 'flex' }}>
      <Button
        extraClass="btn-black secondary"
        onClick={() => {
          setResultStatus('warning');
          setShowResult(true);
          setRefundAmount('');
        }}
      >
        Cancel
      </Button>
      <Button
        extraClass="order-details__confirm"
        disabled={
          refundAmount === '' ||
          Number(refundAmount) === 0 ||
          orderDetails.cashewCustomerId === null ||
          !isRefundAvailable ||
          role === 'CUSTOMER_CARE' ||
          refundLoading
        }
        loading={refundLoading}
        onClick={() => onRefund()}
      >
        {t('button.confirm')}
      </Button>
    </div>
  );
  const resultButtons = (
    <div>
      <Button
        extraClass="btn-blue"
        onClick={() => {
          setResultStatus('none');
          setRefundError('');
          setShowResult(false);
          setShowConfirmModal(false);
        }}
      >
        Ok
      </Button>
    </div>
  );

  return (
    <ModalConfirm
      isVisible={showConfirmModal}
      onClose={() => {
        setShowConfirmModal(false);
      }}
      showCloseButton={false}
      confirmTitle={`Request a refund for the order ${orderDetails.id}`}
      confirmDescription="Please review and confirm below"
      confirmForm={confirmForm}
      confirmButtons={confirmButtons}
      resultTitle={
        ['400.005.017', '400.005.020', '400.005.021'].includes(refundError)
          ? t(`refunds.error.title.${refundError}`)
          : resultTitle
      }
      resultDescriptionComponent={
        ['400.005.017', '400.005.020', '400.005.021'].includes(refundError) ? (
          <div style={{ marginTop: 16 }}>
            {t(`refunds.error.description.${refundError}`)}
          </div>
        ) : (
          resultDescription
        )
      }
      resultButtons={resultButtons}
      showResult={showResult}
      resultStatus={resultStatus}
    />
  );
};
